import api from '../../api/index.js'

const state ={
    qrcodeList:[],
    musicList:[]
}

const getters = {

}

const actions ={
    MyMemorialHallSearch({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/MemorialHall/MyMemorialHallSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    }
}

const mutations ={


}

export default {
    state,
    getters,
    actions,
    mutations
}